import { Facebook, Instagram, YouTube } from "@mui/icons-material";
import Titulos from "./Titulos.blog";
import { useEffect, useState } from "react";

const BlogPageLayout = ({ titulo, autor, fecha, children, articulo }) => {


  const [ultimosArts, setUltimosArts] = useState([])


  const ultimosArticulos = () => {

    const articulos = [
      {
        img: '/img/ahorros.png',
        alt: 'post1',
        href: '/blog/post-1',
        titulo: 'Título del último artículo 1'
      },
      {
        img: '/img/ahorros.png',
        alt: 'post1',
        href: '/blog/post-1',
        titulo: 'Título del último artículo 2'
      },
      {
        img: '/img/ahorros.png',
        alt: 'post1',
        href: '/blog/post-1',
        titulo: 'Título del último artículo 3'
      }
    ]

    setUltimosArts(articulos)
  }

  useEffect(() => {
    ultimosArticulos()
  },[])

  return (
    <div className="container-fluid">
      <div className="row">

        {/* Contenido principal */}
        <div className={`${articulo === 'false' ? 'col-lg-12' : 'col-lg-9'} mb-5`}>
          {articulo === 'true' ?
            <Titulos titulo={titulo} autor={autor} fecha={fecha} />
            : null}
          {children}
        </div>
        {articulo === 'true' ?
          <div className="col-lg-3 mb-5">
            <div className="blog-sidebar">

              {/* Card: Compartir post */}

              <div className="blog-card">
                <h5>Compartir este post</h5>
                <div className="blog-icons">
                  <a href="/" className="blog-icon" aria-label="Facebook">
                    <Facebook />
                  </a>
                  <a href="/" className="blog-icon" aria-label="Instagram">
                    <Instagram />
                  </a>
                  <a href="/" className="blog-icon" aria-label="Twitter">
                    <YouTube />
                  </a>
                </div>
              </div>


              {/* Card: Últimos artículos */}
              <div className="blog-card">
                <h5>Popular</h5>
                <ul className="blog-latest-posts">
                  {ultimosArts && ultimosArts.map((articulo) => (
                    <li key={articulo.titulo}>
                      <img src={articulo.img} alt={articulo.alt} />
                      <a className="fw-bold" href={articulo.href}>{articulo.titulo}</a>
                    </li>
                  ))}
                </ul>
              </div>

            </div>
          </div>
          : null}



      </div>
    </div>


  );
};

export default BlogPageLayout;